module.exports = __webpack_public_path__ + "static/media/usedmachineryformimage.bf954357.jpf";